export default __webpack_public_path__ + "static/media/In_progress-white.a715042b.svg";